module.exports = __webpack_public_path__ + "static/media/vert.32b5a5e3.png";